import { jsx as _jsx } from "react/jsx-runtime";
import { PregnancyDataProvider, Spinner } from "@madmedical/ui";
import { UnderlyingCondition } from "@madmedical/medical";
import { usePatient } from "@madmedical/user";
import { invariant } from "@madmedical/utils";
import { useGetPregnancyDocumentsQuery } from "@madmedical/document";
import { useGetPregnancyByPatientQuery } from "../api";
const PregnancyDataProviderWrapper = ({ children }) => {
    var _a;
    const { patientId, patient, isLoading: isPatientLoading } = usePatient();
    invariant(patient);
    const typedPatient = patient;
    const isPregnant = (_a = typedPatient === null || typedPatient === void 0 ? void 0 : typedPatient.underlyingConditions) === null || _a === void 0 ? void 0 : _a.includes(UnderlyingCondition.Pregnancy);
    const { data: pregnancyData, isLoading: isPregnancyLoading } = useGetPregnancyByPatientQuery({
        patientId,
    }, {
        skip: !isPregnant,
    });
    invariant(pregnancyData);
    const { data: pregnancyDocuments, isLoading: isPregnancyDocumentsLoading } = useGetPregnancyDocumentsQuery({
        patientId,
        page: 1,
        pageSize: 100,
    }, {
        skip: !isPregnant,
    });
    if (isPregnancyLoading || isPatientLoading || isPregnancyDocumentsLoading) {
        return _jsx(Spinner, {});
    }
    return (_jsx(PregnancyDataProvider, Object.assign({ value: {
            pregnancyData,
            patient: typedPatient,
            pregnancyDocuments: pregnancyDocuments === null || pregnancyDocuments === void 0 ? void 0 : pregnancyDocuments.items,
        } }, { children: children })));
};
export default PregnancyDataProviderWrapper;
